import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import requireAuth from '~components/hocs/requireAuth';
import { GscSettings, hasSearchPerformanceAccess } from '~features/SearchPerformance';
import AdminTemplate from '../layout/AdminTemplate';

const TITLES = {
  index: 'Integrations - Prerender.io',
  settings: 'GSC settings - Prerender.io',
} as const;

function IntegrationsLayout() {
  const { pathname } = useLocation();
  const title = pathname.replace(/\/+$/, '').endsWith('/settings') ? TITLES.settings : TITLES.index;

  return (
    <AdminTemplate metaTags={{ title }}>
      <Outlet />
    </AdminTemplate>
  );
}

/**
 * The settings child carries the Search Performance gate on top of the
 * layout's plain auth: `/integrations` is for every customer, the GSC settings
 * reach feature-flagged endpoints (which rest-api guards server-side too).
 */
export const GscSettingsRoute = requireAuth(GscSettings, hasSearchPerformanceAccess);

export default requireAuth(IntegrationsLayout);
